import { render, staticRenderFns } from "./PurchaseForm.vue?vue&type=template&id=cf2408f2&"
import script from "./PurchaseForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports